/** Accept only local app destinations; authentication routes would loop. */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();export function safeCallbackUrl(value: string | null): string | null {
  if (!value || !value.startsWith("/") || value.startsWith("//")) return null

  try {
    const decoded = decodeURIComponent(value)
    if (
      value.trim() !== value ||
      decoded.includes("\\") ||
      Array.from(decoded).some((char) => {
        const code = char.charCodeAt(0)
        return code < 32 || code === 127
      })
    ) {
      return null
    }

    const base = "https://callback.invalid"
    const url = new URL(value, base)
    // Check the decoded path as well, so encoded separators cannot hide auth routes.
    const pathUrl = new URL(decodeURIComponent(url.pathname), base)
    if (
      url.origin !== base ||
      pathUrl.origin !== base ||
      /^\/(?:login|logout|signup|api\/auth)(?:\/|$)/i.test(pathUrl.pathname)
    ) {
      return null
    }

    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return null
  }
}
